import { createSlice } from "@reduxjs/toolkit";
import { submitPatientConsent } from "../../apis/pharmacy/submitPatientConsent";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const patientConsentSlice = createSlice({
    name: 'submitPatientConsent',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(submitPatientConsent.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(submitPatientConsent.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(submitPatientConsent.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default patientConsentSlice.reducer